export type APBModeGlobalName = 'HARD' | 'SOFT' | 'NONE'

export const APBModeGlobal: APBModeGlobalName[] = ['HARD', 'SOFT', 'NONE']
